<!-- app-routing.module.ts Components should have Breadcrumbs at the top -->
<nav class="breadcrumbs">
  <ul class="pagination">
    <li class="dark"><a routerLink="/">{{ dashboardService.client.name }}</a></li>
    <li class="disabled"><a routerLink="/change-log">Change Log</a></li>
  </ul>
  <a routerLink="/change-log/settings"><i class="large glyphicon glyphicon-cog"></i></a>
  <br />
  <a class="underline reverse" *ngIf="dashboardService.website" target="_blank" href="{{ '//' + dashboardService.website.domain }}">
    {{ dashboardService.website.domain }}
  </a>
</nav>

<div *ngIf="!dashboardService.website || !dashboardService.website.commitHistory || !dashboardService.website.commitHistory.length" class="panel panel-default">
  Change Log repository is not configured.
</div>

<div *ngIf="dashboardService.website && dashboardService.website.commitHistory && dashboardService.website.commitHistory.length" class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Change Log
    </h3>
  </div>
  <div class="panel-body center">
    <!-- Change Log Table -->
    <div class="container-fluid table">
      <div class="header row">
        <div class="col-xs-4">Date</div>
        <div class="col-xs-4">Message</div>
        <div class="col-xs-2">Author</div>
        <div class="col-xs-2">Author Email</div>
      </div>
      <div class="row" *ngFor="let commitHistory of dashboardService.website.commitHistory">
        <div class="col-xs-4">{{ commitHistory.commit.author.date | date:'medium' }}</div>
        <div class="col-xs-4">{{ commitHistory.commit.message }}</div>
        <div class="col-xs-2">{{ commitHistory.commit.author.name }}</div>
        <div class="col-xs-2">{{ commitHistory.commit.author.email }}</div>
      </div>
    </div>
  </div>
</div>
